export const environment = {
  production: true,
  enableDebug: false,
  env: "PROD-V3",
  appVersion: "3028784729-3.0.71-20261104-73f9d1fb",
  apiUrl: "https://api.eva-it.ch/api",
  agentUrl: "https://agent.eva-it.ch",
  intercomId: "jdgxwp9j",
  stripePublishableKey:
    "pk_live_51NNbeHKC54OGG3aLbt3kOOPSuZidH8wquslv5YVMoXl4XFQCdSxX5BbLNBrSFAMfT3om5GNWN8kOVrKTLGtruNAl00US7OOw2K",
  googleMapsApiKey: "AIzaSyBqGAICHbDdtOGrSsl1_Yg8d0av7uKSfCM",
};
